import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import type { FunctionComponent } from 'react';

import { useTranslate } from '~/shared/context/use-translate';
import { IconDragHandle } from '~/ui/core/icons';

import { profileTaskTranslationKeys } from '../profile-task-translations';

export const ProfileTaskReorder: FunctionComponent<{
    readonly dragHandleProps: DraggableProvidedDragHandleProps | null;
    readonly index: number;
    readonly total: number;
    readonly onMove: (nextIndex: number) => void;
}> = ({ dragHandleProps, index, onMove, total }) => {
    const translate = useTranslate();

    return (
        <button
            {...dragHandleProps}
            aria-keyshortcuts="ArrowUp ArrowDown"
            aria-label={translate(profileTaskTranslationKeys.reorderTask)}
            className="flex size-6 shrink-0 cursor-grab items-center justify-center rounded-sm border-none bg-transparent p-0 text-text-content-subtle focus-visible:outline focus-visible:outline-1 focus-visible:outline-focus-ring"
            data-testid="profile-task-reorder"
            type="button"
            onKeyDown={(event) => {
                if (event.key === 'ArrowUp' && index > 0) {
                    event.preventDefault();
                    onMove(index - 1);
                    return;
                }
                if (event.key === 'ArrowDown' && index < total - 1) {
                    event.preventDefault();
                    onMove(index + 1);
                }
            }}
        >
            <IconDragHandle size={16} />
        </button>
    );
};
